export const DEFAULT_ADDRESS_LINE_ORDER = [
  "address1",
  "address2",
  "address3",
  "address4",  
  "address5",
  "zip",
  "city",
  "country",
  "reference",
  "email",
  "telephone",
  "contact",
  "customerId"
];

//DraggableAddrss, addressModal
export const ADDRESS_LINE_DEFINITIONS = {
  address1: { label: "Adressrad 1", messageId: "addresses.defaultLabel.address1", defaultType: "REQUIRED" },
  address2: { label: "Adressrad 2", messageId: "addresses.defaultLabel.address2", defaultType: "OPTIONAL" },
  address3: { label: "Adressrad 3", messageId: "addresses.defaultLabel.address3", defaultType: "OPTIONAL" },
  address4: { label: "Adressrad 4", messageId: "addresses.defaultLabel.address4", defaultType: "OPTIONAL" },
  address5: { label: "Adressrad 5", messageId: "addresses.defaultLabel.address5", defaultType: "OPTIONAL" },
  zip: { label: "Postnummer", messageId: "addresses.defaultLabel.zip", defaultType: "REQUIRED" },
  city: { label: "Postort", messageId: "addresses.defaultLabel.city", defaultType: "REQUIRED" },
  country: {  label: "Land", messageId: "addresses.defaultLabel.country", defaultType: "REQUIRED", type: "country"  },
  contact: { label: "Kontakt / mottagare", messageId: "addresses.defaultLabel.contact", defaultType: "OPTIONAL" },
  reference: { label: "Referens", messageId: "addresses.defaultLabel.reference", defaultType: "OPTIONAL" },
  email: { label: "E-post", messageId: "addresses.defaultLabel.email", defaultType: "OPTIONAL" },
  telephone: { label: "Telefon", messageId: "addresses.defaultLabel.telephone", defaultType: "OPTIONAL" },
};

//addressModal
export const getDefaultAddressFieldSetting = (fieldKey, index) => {
  const definition = ADDRESS_LINE_DEFINITIONS[fieldKey] || {};
  return {
    displayOrder: index,
    label: definition.label || fieldKey,
    type: definition.defaultType || "OPTIONAL",
    placeholder: "",
  };
};

//overrideModel, addressModel
export const getAddressFieldSetting = (address, fieldKey) =>
  address?.fieldSettings?.[fieldKey] ||
  getDefaultAddressFieldSetting(
    fieldKey,
    DEFAULT_ADDRESS_LINE_ORDER.indexOf(fieldKey)
  );

//overrodeModel, addressModel
export const isHiddenAddressField = (address, fieldKey) =>
  getAddressFieldSetting(address, fieldKey).type === "HIDDEN";

//overrodeModel, addressModel
export const hasAddressFieldData = (address, fieldKey) =>
  String(address?.[fieldKey] ?? "").trim() !== "";



/*
 * Normalize an address that is already in the CustomerCard's canonical shape.
 * Raw backend aliases belong in organizationAdapter.js, not here.
 */
export const normalizeCustomerAddress = address => {
  const source = address || {};
  const sourceSettings = source.fieldSettings || {};

  const settingsOrder = Object.entries(sourceSettings)
    .filter(([fieldKey]) => DEFAULT_ADDRESS_LINE_ORDER.includes(fieldKey))
    .sort(
      ([, left], [, right]) =>
        Number(left?.displayOrder || 0) - Number(right?.displayOrder || 0)
    )
    .map(([fieldKey]) => fieldKey);

  const savedOrder =
    Array.isArray(source.lineOrder) && source.lineOrder.length
      ? source.lineOrder.filter(key => DEFAULT_ADDRESS_LINE_ORDER.includes(key))
      : settingsOrder;

  const missingLines = DEFAULT_ADDRESS_LINE_ORDER.filter(
    key => !savedOrder.includes(key)
  );
  const lineOrder = [...savedOrder, ...missingLines];

  const fieldSettings = lineOrder.reduce((result, fieldKey, index) => {
    const fallback = getDefaultAddressFieldSetting(fieldKey, index);
    const incoming = sourceSettings[fieldKey] || {};
    result[fieldKey] = {
      ...fallback,
      ...incoming,
      displayOrder: index,
      type: incoming.type || fallback.type,
    };
    return result;
  }, {});

  return {
    
    ...source,
    // Legacy CustomerCard compatibility; raw organization aliases still stop in the adapter.
    country: source.country || "",
    lineOrder,
    fieldSettings,
  };
};

export const cloneAddress = address => {
  const source = normalizeCustomerAddress(address);
  return {
    ...source,
    lineOrder: [...source.lineOrder],
    fieldSettings: { ...source.fieldSettings },
  };
};

export const isAddressComplete = address =>
  (address?.lineOrder || [])
    .filter(
      fieldKey => getAddressFieldSetting(address, fieldKey).type === "REQUIRED"
    )
    .every(fieldKey => hasAddressFieldData(address, fieldKey));
